import React from 'react';
import { Page } from '@wix/design-system';
import { CollectionPageContentElement } from '../../components/CollectionPageContent';

export function useCollectionPageContent(child: CollectionPageContentElement) {
  return <Page.Content {...child.props} />;
}
